// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-navigation-spacer[data-v-3dd6c4f7] {
  flex-shrink: 0;
  height: 22px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcAppNavigationSpacer-C5p-33VT.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,YAAY;AACd","sourcesContent":[".app-navigation-spacer[data-v-3dd6c4f7] {\n  flex-shrink: 0;\n  height: 22px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
